import { validators } from "../../validators/validators"

export const validateEmail = (email) => {
    let err = validators.ValidateEmail(email)
    if (err != null) {
        return "errors.email.invalid_format"
    }
}

export const validatePassword = (password) => {
    if (password.length < 8) {
        return "registration.password_min_8"
    }
}